import React from "react";
import { addToAppliedJobs, applyJob } from "../../../APIs/PostAPIS";
import { MainContext } from "../../Dashboard/DashboardContext/Context";
import "./apply-for-job.style.scss";
import ApplyJobConfirm from "./ApplyJobConfirm";
import ApplyJobSuccess from "./ApplyJobSuccess";
export default function ApplyForJob({ closeIt, jobInfo }) {
  const [first, setFirst] = React.useState(true);
  const [applying, setApplying] = React.useState(false)
  const context = React.useContext(MainContext)
  const {userDetails, setUpSavedJobArray} = context
  const handleApply = async() =>{
    setApplying(true)
    try {
      let temp = {
        jobTitle:jobInfo.jobTitle || "",
        city:jobInfo.city || "",
        country:jobInfo.country || "",
        jobCategory:jobInfo.jobCategory || "",
        custField4:jobInfo.custField4 || "",
        jobDescription:jobInfo.jobDescription || "",
        start:"1",
        websitePublish:jobInfo.websitePublish || "",
      }
      let res = await applyJob(jobInfo.jobId, userDetails.user_id)
      if (res.data.statusCode === 200) {
        setUpSavedJobArray()
        setApplying(false);
        setFirst(false)
      } else {
        alert("Not Applied");
        setApplying(false);
      }

    } catch (error) {
      console.error(error)
      setApplying(false);
      
    }
  }
  return (
    <div className="apply-for-job-wrapper">
      <div className="apply-for-job-modal">
        {first ? (
          <ApplyJobConfirm handleConfirm ={handleApply} applying={applying} closeIt={closeIt} setFirst={setFirst} />
        ) : (
          <ApplyJobSuccess closeIt={closeIt} />
        )}
      </div>
    </div>
  );
}
